import React, { useEffect, useState } from 'react';
import './AddToHomePrompt.css';
import { isNativeShell } from '../auth/authRedirect';

export default function AddToHomePrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIOSPrompt, setShowIOSPrompt] = useState(false);

  useEffect(() => {
    // The native Capacitor app is already installed. Never show PWA install UI.
    if (isNativeShell()) {
      setDeferredPrompt(null);
      setShowIOSPrompt(false);
      return;
    }

    // Chrome‐style install prompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // iOS detection: Safari, not already standalone, on mobile Safari UA
    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    const isInStandalone = ('standalone' in window.navigator) && window.navigator.standalone;
    if (isIos && !isInStandalone) {
      setShowIOSPrompt(true);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const choice = await deferredPrompt.userChoice;
      if (choice.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      }
      setDeferredPrompt(null);
    }
  };

  const handleClose = () => {
    setShowIOSPrompt(false);
  };

  if (deferredPrompt) {
    // Native prompt available
    return (
      <div className="ath-prompt">
        <button onClick={handleInstallClick} className="ath-button">
          ➕ Add to Home Screen
        </button>
      </div>
    );
  }

  if (showIOSPrompt) {
    // Show custom iOS instructions
    return (
      <div className="ath-prompt">
        <div className="ath-ios-instructions">
          <p>To install this app:</p>
          <ol>
            <li>Tap the “Share” icon&nbsp;↗️</li>
            <li>Select “Add to Home Screen”</li>
          </ol>
          <button onClick={handleClose} className="ath-close">✕</button>
        </div>
      </div>
    );
  }

  return null;
}
